export default "__VITE_ASSET__DunmeDbi__"